import { Component, Input } from '@angular/core';
import { Fluid } from 'primeng/fluid';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Textarea } from 'primeng/textarea';
import { Card } from 'primeng/card';
import { NgClass } from '@angular/common';

export const MOTIVATION_MAX_LENGTH: number = 8000;
export const MOTIVATION_MIN_LENGTH: number = 1500;

@Component({
  selector: 'app-motivation[motivation]',
  imports: [Fluid, ReactiveFormsModule, Textarea, Card, NgClass],
  templateUrl: './motivation.component.html',
  styleUrl: './motivation.component.scss'
})
export class MotivationComponent {
  @Input()
  public motivation!: FormControl<string | null>;

  protected readonly motivationMaxLength: number = MOTIVATION_MAX_LENGTH;
}
